import React, { useEffect, useRef } from 'react';
import moment from 'moment';

// locales
import { useTranslation } from 'react-i18next';
import { translations } from '../../../locales/i18n';

// components

// styles
import { ATCDropdownList } from './styles';

export function ATCDropdown(args) {
  const ref = useRef<HTMLUListElement>(null);
  const clickOut = e => {
    if (ref.current !== null && !ref.current.contains(e.target)) {
      args.onRequestClose(e);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', clickOut);
    return () => {
      window.removeEventListener('mousedown', clickOut);
    };
  }, []);

  return (
    <>
      <ATCDropdownList ref={ref}>
        {args.children.map((link, i) => (
          <li key={i}>{link}</li>
        ))}
      </ATCDropdownList>
    </>
  );
}

export default ATCDropdown;
